// extracted by mini-css-extract-plugin
module.exports = {"warning":"style_warning__17EPf","note":"style_note__HLA_f","titleContainer":"style_titleContainer__2cHjn","title":"style_title__2kfxM","detailLink":"style_detailLink__3seHs"};